/* eslint-disable no-unused-vars */
import { LikeHeart } from '@components/Icons'
import { useGetLikes } from '@hooks/useRequest'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import Confetti from 'react-dom-confetti'

import styles from './Like.module.scss'

export default function Like({ data }) {
  const dynamicRoute = useRouter().asPath

  const [totalLikes, setTotalLikes] = useState(data.likes)
  const [liked, setLiked] = useState(false)
  const [isLoading, setISLoading] = useState(false)

  useEffect(() => {
    setLiked(false)
    setTotalLikes(data.likes)
  }, [data, dynamicRoute])

  const articleId = data._id

  const { currentLikes } = useGetLikes(articleId)
  // console.log('💕 CURRENT LIKES 💕: ', currentLikes)

  const config = {
    angle: '90',
    spread: '40',
    startVelocity: '25',
    elementCount: '20',
    dragFriction: '0.1',
    duration: '4000',
    stagger: '5',
    width: '5px',
    height: '5px',
    perspective: '535px',
    colors: ['#ffbdd5', '#F5DFE6', '#bfed72', '#efefef', '#999999'],
  }

  async function sendVote(req, _res) {
    req.preventDefault()
    setISLoading(true)
    const result = await fetch('/api/sanity/like', {
      method: 'POST',
      body: JSON.stringify({ articleId }),
    })
      .then((res) => res.json())
      .catch((err) => console.error(err))

    setTotalLikes(result.likes)
    setLiked(true)
    setISLoading(false)
  }

  const colour = data.colour

  return (
    <div className={styles.wrapper}>
      <button type="button" disabled={liked} onClick={!liked && sendVote}>
        <>
          {liked ? (
            <LikeHeart colour={colour.vibrant.background} />
          ) : (
            <>
              {
              isLoading ? <span>Loading...</span> : 
              <> 
                <LikeHeart colour={colour.vibrant.background} empty />
                <p>{totalLikes || 0} Likes</p>
              </>
              }
            </>
          )}
        </>
      </button>
      <Confetti active={liked} config={config} />
    </div>
  )
}
